import { Breadcrumb } from '@components/breadcrumb';
import { Button } from '@components/button';
import { Header } from '@components/header';
import { PageContainers } from '@components/page-containers';
import { PageContent } from '@components/page-containers/page-container';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useChangePasswordModal } from './change-password-modal';

export const MySecurity = () => {
  const { t } = useScopedTranslate(locale);

  const showPasswordModal = useChangePasswordModal();

  return (
    <>
      <Header breadcrumbs={<Breadcrumb items={[{ label: t('security') }]} />} />
      <PageContent>
        <PageContainers.MiddleColumnPage>
          <Stack space={6}>
            <Text font="regular14" color="textSecondary" text={t('manageYourPassword')} />
            <Separator />
            <Stack orientation="horizontal" justify="space-between">
              <div>
                <Text font="bold16" text={t('password')} />
                <Text font="regular14" color="textSecondary" text={t('setUniquePassword')} />
              </div>
              <Button
                variant="secondary"
                text={t('changePassword')}
                onClick={() => showPasswordModal()}
              />
            </Stack>
          </Stack>
        </PageContainers.MiddleColumnPage>
      </PageContent>
    </>
  );
};

export const locale = {
  en: {
    security: 'Security',
    manageYourPassword: 'Manage your password and authentication methods',
    password: 'Password',
    setUniquePassword: 'Set a unique password to protect your account',
    changePassword: 'Change password',
  },
};
